import React from 'react';
import '../template-file-css/document-file-template.css';


export const OABS_AnnualPsychiatric = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='OABS_AnnualPsychiatric' className='file-pdf-document'>

            <div className='file-template'>


                <p className='w-750'><h3>Common Items </h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Participant Accompanied By</span>
                            <span className='small'>(check all that apply):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbParticipantAccompanied_1' name='cbParticipantAccompanied_1' className='add-only' value='Self' /> Self</td>
                        <td className='w-187'><input type='checkbox' id='cbParticipantAccompanied_2' name='cbParticipantAccompanied_2' className='add-only' value='Family' /> Family</td>
                        <td className='w-187'><input type='checkbox' id='cbParticipantAccompanied_3' name='cbParticipantAccompanied_3' className='add-only' value='SignificantOther' /> Significant Other</td>
                        <td className='w-187'><input type='checkbox' id='cbParticipantAccompanied_4' name='cbParticipantAccompanied_4' className='add-only' value='LegalGuardian' /> Legal Guardian</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbParticipantAccompanied_5' name='cbParticipantAccompanied_5' className='add-only' value='Other' /> Other :
                            <input type='text' id='txtParticipantAccompanied_5' name='txtParticipantAccompanied_5' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Legal Guardian/Custodian Name</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtLegalGuardianName' name='txtLegalGuardianName' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>History of Present Problem(s)</span>
                            <span className='small'>(When began, duration/intensity of symptons, stressors/precipitants, list participants conception of presenting problems and what the
                                participant perceives to be the important issues to be addressed.):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtHistoryPresentProblems' name='txtHistoryPresentProblems' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Prior MH/SA/DD History</span>
                            <span className='small'>(Include residential treatment, inpatient, outpatient, etc.):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPriorMhSaDdHistory' name='txtPriorMhSaDdHistory' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>History of Traumatic Events</span>
                            <span className='small'>(Consider neglect or abuse, violence, significant losses, accidents, etc.):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtHistoryTraumaticEvents' name='txtHistoryTraumaticEvents' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Current Living Situation</span>
                            <span className='small'>(Where, with whom, relationship, etc.):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCurrentLivingSituation' name='txtCurrentLivingSituation' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Education History</span>
                            <span className='small'>(Consider special education, behavior programs, grade level - current or achieved, school, attitude, etc.):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtEducationHistory' name='txtEducationHistory' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Vocational History</span>
                            <span className='small'>(Include current Employment, military, vocational difficulties, handicaps, if unemployed - work plan, etc.):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtVocationalHistory' name='txtVocationalHistory' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Family History</span>
                            <span className='small'>(Include any MH/DD/SA history of biological family, immediate family/significant others, diagnosis, treatment, etc.):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtFamilyHistory' name='txtFamilyHistory' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Social History</span>
                            <span className='small'>(Include friendships, significant relationships, religious and cultural activities, hobbies, recreation):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSocialHistory' name='txtSocialHistory' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Transcultural Factors</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtTransculturalFactors' name='txtTransculturalFactors' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><h3>ANNUAL PSYCHIATRIC UPDATE</h3></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Individual Accompany by</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtIndividualAccompanyBy' name='txtIndividualAccompanyBy' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>(Vitals) B/P</span></td>
                        <td className='w-250'><span className='eleHeader'>Pulse</span></td>
                        <td className='w-250'><span className='eleHeader'>Weight</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtIndividualAccompanyVitals' name='txtIndividualAccompanyVitals' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtIndividualAccompanyPulse' name='txtIndividualAccompanyPulse' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtIndividualAccompanyWeight' name='txtIndividualAccompanyWeight' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Presenting Problems</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPresentingProblems' name='txtPresentingProblems' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Changes/New Problems</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtChangesNewProblems' name='txtChangesNewProblems' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><h3>MEDICATION EDUCATION</h3></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Side Effects/Benefits</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSideEffectsBenefits' name='txtSideEffectsBenefits' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Compliance/Non-Compliance</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtComplianceNonCompliance' name='txtComplianceNonCompliance' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Purpose/Efficacy, etc</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPurposeEfficacy' name='txtPurposeEfficacy' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Appetite</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAppetite' name='txtAppetite' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Sleeping Patterns</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSleepingPatterns' name='txtSleepingPatterns' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Motivation</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtMotivation' name='txtMotivation' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>OTC Medications</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtOtxMedications' name='txtOtxMedications' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Dietary Restrictions</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtDietaryRestrictions' name='txtDietaryRestrictions' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Homeopathic Therapies</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtHomeopathicTherapies' name='txtHomeopathicTherapies' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Need for further medical/la testing</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtNeedFurtherMedical' name='txtNeedFurtherMedical' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Clinical Impressions</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtClinicalImpressions' name='txtClinicalImpressions' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>MSE Overview</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtMseOverview' name='txtMseOverview' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Risk Factors</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtRiskFactors' name='txtRiskFactors' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>DIAGNOSITC IMPRESSIONS</span>
                            <span className='small'>(Indicate diagnostic changes since Initial Psychiatric Evaluation):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtDiagnosticImpressions' name='txtDiagnosticImpressions' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Progress/Prognosis</span>
                            <span className='small'>(Since Initial Psychiatric Evaluation):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtProgressPrognosis' name='txtProgressPrognosis' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>TREATMENT PLAN</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtTreatmentPlan' name='txtTreatmentPlan' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>MEDICATIONS</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtMedication' name='txtMedication' className='add-only' />
                            <span className='small'>(Changes):</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>(Follow-up & Projected Date of Discharge)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtFollowupProjectedDateDischarge' name='txtFollowupProjectedDateDischarge' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Psychiatrist Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Assessment History</span>
                    <textarea id='txtAssessmentHistory' name='txtAssessmentHistory' className='add-only' ></textarea>
                </p>


            </div>
        </form>

    )
}







